import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./../StockCard.css"; // Importing the CSS file
import upIcon from '../assets/up_icon.png';
import downIcon from '../assets/down_icon.png';

const ScoreCard = ({ stock, _stock, onCardClick, isDarkMode = false, proView = false, positions = [], netPositions = [] }) => {
  const { Symbol, Ask, Bid, LTP, High, Low, Open, Prev_Close, ExpiryDate } = stock;
  const [prevBid, setPrevBid] = useState(_stock.Bid);
  const [prevAsk, setPrevAsk] = useState(_stock.Ask);
  const navigate = useNavigate();


  // Calculate the change percentage
  const _Bid = _stock.Bid!=undefined ? _stock.Bid : stock.buyPrice;
  const _Ask = _stock.Ask!=undefined ? _stock.Ask : stock.sellPrice;
  const _Open = _stock.Open!=undefined ? _stock.Open : stock.open;
  const _High = _stock.High!=undefined ? _stock.High : stock.high;
  const _Low = _stock.Low!=undefined ? _stock.Low : stock.low;
  const _Prev_Close = _stock.Prev_Close!=undefined ? _stock.Prev_Close : stock.close;
  const _LTP = _stock.LTP!=undefined ? _stock.LTP : stock.lastTradedPrice;

  const Change_per = ((_LTP - _Prev_Close) / _Prev_Close * 100).toFixed(2);
  const Change = (_LTP - _Prev_Close).toFixed(2);
  const changeColor = Change > 0 ? "green" : "red";

  // Handle quantity click to navigate to NetPositions
  const handleQuantityClick = (e) => {
    e.stopPropagation(); // Prevent card click event
    navigate('/net-positions', { 
      state: { 
        filterByScript: stock.dispname || stock.stockName 
      } 
    });
  };

  // console.log("positions", positions);

  // Calculate quantity from portfolio positions
  const getQuantityFromPositions = () => {
    // console.log("getQuantityFromPositions", "Called");
    // console.log("positions", positions.length);
    if(positions.length > 0)
    { 
      if (!positions || positions.length === 0) return 0;
      
      // Find all positions for this stock (multiple positions possible)
      const matchingPositions = positions.filter(pos => {
        return pos.instrument_token == stock.instrument_token;
      });

      // console.log("Matching positions found:", matchingPositions.length);
      // console.log("Matching positions:", matchingPositions);
      
      if (matchingPositions.length === 0) return 0;
      
      // Sum all orderLotQuantity from matching positions
      const totalLots = matchingPositions.reduce((sum, position) => {
        const lots = position.orderLotQuantity || position.lots || 0;
        // console.log("Adding lots:", lots, "from position:", position.orderId);
        return sum + Number(lots);
      }, 0);
      
      // console.log("Total lots for", stock.instrument_token, ":", totalLots);
      return totalLots;
    }
    else
    {
      return 0;
    }
  };

  const [quantity, setQuantity] = useState(0);

  // useEffect(() => {
  //   console.log("StockCard", "useEffect Called");
  //   setQuantity(getQuantityFromPositions());
  // }, [positions]);

  const getQuantityFromNetPositions = () => {
    if(netPositions.length > 0)
    {
      return netPositions.find(pos => pos.stockId == stock.instrumentIdentifier)?.netQty || 0;
    }
    else
    {
      return 0;
    }
  };

  useEffect(() => {
    console.log("StockCard", "useEffect Called");
    setQuantity(getQuantityFromNetPositions());
  }, [netPositions]);
  
  const handleClick = () => {
    stock['live'] = _stock;
    onCardClick(stock);
  };

  const [bidChangeClass, setBidClass] = useState('green');
  const [askChangeClass, setAskClass] = useState('red');

  // Compare Bid and Ask with previous values
  // const bidChangeClass = _Bid > prevBid ? 'green' : _Bid < prevBid ? 'red' : '';
  // const askChangeClass = _Ask > prevAsk ? 'green' : _Ask < prevAsk ? 'red' : '';

  // Update the previous values on every render
  useEffect(() => {
    if (_Bid !== prevBid) {
      //console.log(`Bid changed: Old Bid = ${prevBid}, New Bid = ${_Bid}`);
     let a = _Bid > prevBid ? setBidClass('green') : _Bid < prevBid ? setBidClass('red') : '';
    }
    if (_Ask !== prevAsk) {
      //console.log(`Ask changed: Old Ask = ${prevAsk}, New Ask = ${_Ask}`);
      let b = _Ask > prevAsk ? setAskClass('green') : _Ask < prevAsk ? setAskClass('red') : '';
    }
    setPrevBid(_Bid);
    setPrevAsk(_Ask);
    
  }, [_Bid, _Ask]);

  return (
    <div className={`commodity-card ${isDarkMode ? 'dark-theme' : 'light-theme'}`} onClick={handleClick}>
      {proView ? (
        // Pro View - Full Detailed Card
        <>
          {/* Change and Script Info */}
          <div className="commodity-header">
            <div className="change-info">
              <span className={`change-value ${changeColor}`}>
                {Math.abs(Change).toFixed(2)} ({Math.abs(Change_per)}%)
              </span>
              {Change > 0 ? (
                <span className="change-arrow up">▲</span>
              ) : (
                <span className="change-arrow down">▼</span>
              )}
            </div>
            <div className="qty-info" onClick={handleQuantityClick} style={{ cursor: 'pointer' }}>Qty: {quantity}</div>
            <div className="ltp-info">
              <span className="price-label">LTP:</span>
              <span className="price-value">{Number(_LTP).toFixed(2)}</span>
            </div>
          </div>

          {/* Price Information */}
          <div className="price-section">
            <div className="script-info">
              <div className={`script-name ${stock.exchange === 'OPTSTK' ? 'optstk-font' : 'normal-font'}`}>{stock.dispname}</div>
              <div className="script-expiry">{stock.expiry}</div>
            </div>
            <div className="price-left">
              
              <div className="bid-price">
                {/* <span className="price-value">{Number(_Bid).toFixed(2)}</span> */}
                <span className={`price-value stock-price ${bidChangeClass}`}>{Number(_Bid).toFixed(2)}</span>
              </div>
              <div className="high-price">
                <span className="price-label">H</span>
                <span className="price-value">{Number(_High).toFixed(2)}</span>
              </div>
            </div>
            <div className="price-right">
              
              <div className="ask-price">
                {/* <span className="price-value">{Number(_Ask).toFixed(2)}</span> */}
                <span className={`price-value stock-price ${askChangeClass}`}>{Number(_Ask).toFixed(2)}</span>
              </div>
              <div className="low-price">
                <span className="price-label">L</span>
                <span className="price-value">{Number(_Low).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </>
      ) : (
        // Simple View - Compact Card with Bid/Ask Only
        <div className="simple-card-content">
          <div className="stock-info">
            <div className="stock-name">{stock.dispname}</div>
            <div className="bid-price">
              <span className="price-label">Bid</span>
              <span className={`price-value stock-price ${bidChangeClass}`}>{Number(_Bid).toFixed(2)}</span>
            </div>
            <div className="ask-price">
              <span className="price-label">Ask</span>
              <span className={`price-value stock-price ${askChangeClass}`}>{Number(_Ask).toFixed(2)}</span>
            </div>
          </div>
          {/* <div className="bid-ask-prices">
            <div className="bid-price">
              <span className="price-label">Bid:</span>
              <span className="price-value">₹{Number(_Bid).toFixed(2)}</span>
            </div>
            <div className="ask-price">
              <span className="price-label">Ask:</span>
              <span className="price-value">₹{Number(_Ask).toFixed(2)}</span>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default ScoreCard;
